module.exports = __webpack_public_path__ + "img/pm.e68a44a4.svg";